export const API_CONSTANTS = Object.freeze({
  GET_VISITS: "/visits"
});
